import * as yup from 'yup';

import { IS_REQUIRED, isGreaterThanOrEqualTo } from '@occc-app/lib/constants/validationMessages';
import { Limit_Time_Period } from '@occc/graphql';

export const progressPerPeriodSchema = yup
  .object()
  .shape({
    isEnabled: yup.boolean(),
    limit: yup.number().when('isEnabled', {
      is: true,
      then: () => yup.number().min(1, isGreaterThanOrEqualTo(1)).required(IS_REQUIRED),
    }),
    timePeriod: yup
      .mixed()
      .oneOf(Object.values(Limit_Time_Period))
      .when('isEnabled', {
        is: true,
        then: (schema) => schema.required(IS_REQUIRED),
      }),
  })
  .optional();
